import React from 'react';
import styles from '../about.module.css';
import {ABOUT_PAGE_CONTENT} from "../aboutPageContent";

const History: React.FC = () => {
    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.text_content}>
                    <h2 className={styles.section_title}>
                        {ABOUT_PAGE_CONTENT.history.title}
                    </h2>
                    <p className={styles.intro_paragraph}>
                        {ABOUT_PAGE_CONTENT.history.paragraph}
                    </p>
                </div>
                <div className={styles.image_container}>
                    <img
                        src="/images/about/values.jpg"
                        alt="Espace chaleureux de la garderie"
                        className={styles.image}
                    />
                </div>
            </div>
        </section>
    );
};

export default History;
